// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3onv6","content":"styles_content__31QMh","tableWrap":"styles_tableWrap__1DJ5d"};